<template>
    <section class="font-poppins text-sm">
        <div>
            <section class=" mt-10">
                <div class="text-sm flex justify-end md:flex-col ">
                    
                    <div>
                        <input v-model="searchQuery" @click="search = !search" class="border outline-none w-72 p-2 rounded-lg bg-gray-100 text-xs" type="text" name="search" id="search" placeholder="Search name, email...">
                        <i class="fa fa-search -ml-8 md:hidden"></i>
                    </div>
                </div>
            </section>
            <div>
                <div class=" font-bold flex text-xl md:text-lg mb-2 md:mt-2">
                    <p>User List</p>
                    <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                </div>
                
            </div>
            
            <div class="md:overflow-x-auto">
                <table class="w-full mt-5">
                    <tbody>
                        <tr class="text-left  border-b-2">
                            <th class="w-40">Name</th>
                            <th class="w-40">Email</th>
                            <th class="w-40">Phone Number</th>
                            <th class="w-40">Status</th>
                            <th class="w-40">Date Joined</th>
                        </tr>
                        
                        <tr v-for="user in filterName" :key="user" class="hover:bg-gray-300 hover:border  hover:border-blue-700 p-2 border-b-2">
                            <td>{{user.firstName}} {{user.lastName}}</td>
                            <td class="text-blue-700 p-2">{{user.email}}</td>
                            <td>{{user.phone}}</td>
                            <td>
                                <span v-if="user.status === 'blocked'" class="blocked"><i class="fa fa-circle mr-1 "></i>{{user.status}}</span> 
                                <span v-if="user.status === 'active'" class="active"><i class="fa fa-circle mr-1"></i>{{user.status}}</span> 
                                <span v-if="user.status === 'pending'" class="active"><i class="fa fa-circle mr-1 "></i>active</span> 
                                <span v-if="user.status === 'suspended'" class="blocked"><i class="fa fa-circle mr-1 "></i>{{user.status}}</span> 
                            </td>
                            <td>{{moment(user.updated_at).format('DD/MM/YYYY')}}<span @click="toggleList(user)" class=" fa fa-ellipsis-v ml-3 cursor-pointer text-gray-500"></span>
                            <div class=" relative">
                                <ul class="absolute text-xs bg-gray-50 pl-8 pt-4 pb-4 pr-8" v-show="user.navList">
                                     <li><router-link :to="{name: 'user-info', params: {id: user.id}}" class="border-b-2 cursor-pointer">View Info</router-link></li>
                                    <li><router-link :to="{name: 'email-center', params: {id:user.email}}" class="border-b-2  cursor-pointer">Message</router-link></li>
                                    <li v-if="user.status === 'active' || user.status === 'approved' || user.status === 'pending' "  @click="blockUser(user)" class="mt-2 border-b-2 cursor-pointer ">Block User</li>
                                    <li v-show="user.status ==='blocked' " @click="unblockUser(user)" class="mt-2 border-b-2 cursor-pointer ">Unblock User</li>
                                    <li @click="deleteUserModal(user)" class="mt-2 border-b-2 cursor-pointer">Delete User</li>
                                </ul>
                                
                            </div></td>
                            
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        </div>

        <div v-if="!searchQuery" class="flex justify-between mt-10 text-gray-500">
            <div>
                 <p>Showing {{currentPage}} of {{totalPages}} Pages of {{totalUsers}} Users </p>

            </div>

            <div class="flex">
                <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
            </div>
        </div>
        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getUsers="getUsers"
            :userId="userId"
            />
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import {baseUrl} from '../../../Config';
const url = baseUrl;
import DeleteModal from '../DeleteModal.vue';
export default {
    components:{DeleteModal},
    data() {
        return {
            navList: false,
            searchQuery: '',
            users: [],
            page: 1,
            search: null,
            selectedName: null,
            showFilter: true,
            isLoading: false,
            status: "blocked",
            unblockStatus: "active",
            isActive:false,
            totalUsers: "",
            pageCount: "",
            block: "",
            unblock: "",
            deleteModal: false,
            message: "",
            userId: "",
            currentPage:1,
            pageSize:20,
            searchLength: "",
            totalPages: "",
        }
    },

    computed: {
        filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.users.filter((theOrder) => {  
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.users.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.users.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                 if(this.totalPages == 0) {
                    this.totalPages = 1
                }
                if(index >= start && index < end) return true;
                })
            }
        }
    },

    mounted() {
        this.getUsers();
        this.networkError();
    },

    methods: {
        moment(date) {
            return moment(date)
        },
        closeModal() {
            this.deleteModal = false;
        },
        deleteUserModal(user) {
            this.userId = user.id;
            user.navList = !user.navList
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        toggleList(user) {
                localStorage.setItem("theId", user.id)
                user.navList = !user.navList
           
        },
        next() {
            if((this.currentPage*this.pageSize) < this.users.length) this.currentPage++;
        },

        prev() {
            if(this.currentPage > 1) this.currentPage--
        },
        blockUser(user) {  
            user.navList = !user.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/users/${user.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.status
                }
            })
            .then((response) => {
                if(response.data.data.status === "blocked") {
                    this.getUsers()
                }
            }) 
            .catch((error) => {
                console.log(error)
            })

            if (!user.isActive) {
                user.isActive = true
            } else{
                user.isActive = false
            }
        },
        unblockUser(user) {  
            user.navList = !user.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/users/${user.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.getUsers();
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },


        
        showDetails(eachUser) {
            this.selectedName = eachUser;
            this.showFilter = false
            this.getUsers()
        },

        getUsers() {
            this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/users?sortBy=role&limit=1000&page=1&userType=user`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.users = response.data.data.results;
                this.isLoading = false;
                this.pageCount = this.users.length
                this.totalUsers = response.data.data.totalResults
                
            })
            .catch((error) => {
                console.log(error)
            })   
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.pending {
    color: rgba(240, 240, 44, 0.931);
}

.active{color: green;}
.blocked{color:red}
</style>
